import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams } from "../../../../utils/pacto-rebates-utils";

export function useDeclineNetSalesDelete() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function deleteDeclineNetSales(declineNetSalesId) {
		if (!declineNetSalesId) {
			const validationMessage = "Não foi possível identificar a penalidade por queda em Net Sales (Grupo).";

			setError(validationMessage);

			return {
				ok: false,
				reason: "validation",
				error: validationMessage
			};
		}

		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/penalidades-queda-grupo/${encodeURIComponent(declineNetSalesId)}`,
				{
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(response, "Não foi possível excluir a penalidade por queda em Net Sales (Grupo).");
			}

			return { ok: true };
		} catch (requestError) {
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		loading,
		error,
		deleteDeclineNetSales
	};
}